import { apiRequest } from '@common/api/utils';
import {
  getAttribution,
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { INTENTS } from '@common/vanilla_ui/tracking/constants';

const BASE_URL = '/api/v4/event_groups';

const PROGRAM_TO_SLUG = {
  academy: 'free-class-with-founders-academy',
  data_science: 'free-class-with-founders-dsml',
  devops: 'free-class-with-founders-academy',
};


const getRegistrationAttributions = () => {
  setAttribution(INTENTS.BOOK_LIVE_CLASS);

  return getAttribution();
};

export const getUpcomingLiveClass = (program = 'academy') => apiRequest(
  'GET',
  `${BASE_URL}/${PROGRAM_TO_SLUG[program]}`,
  {},
  {
    headers: {
      'X-user-token': window.__INITIAL_STATE__.authToken,
    },
  },
);

export const eventRegisteration = (id) => apiRequest(
  'POST',
  `/api/v3/events/${id}/registration`,
  {
    attributions: getRegistrationAttributions(),
  },
);
